/**
 * reader-style-preset (= 副次 spec) の起動 button + SettingsPanel modal host。
 *
 * - gear icon (= ⚙) で SettingsPanel modal を起動
 * - useState で modal open 状態を管理 (= host コンポーネントから state 分離)
 * - aria-label "読書設定" (= a11y、 screen reader 読み上げ用)
 * - 既存 PlayerScreen の floating element pattern を踏襲、 固定右上配置
 *
 * 設計詳細は `.kiro/specs/reader-style-preset/design.md` を参照。
 */

import { useState, type JSX } from "react";
import { SettingsPanel } from "./SettingsPanel";

export function ReaderHeaderSettingsButton(): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        aria-label="読書設定"
        data-testid="reader-style-settings-button"
        onClick={() => {
          setOpen(true);
        }}
        className="fixed z-40 flex h-11 w-11 items-center justify-center rounded-full bg-reader-surface text-lg text-reader-secondary shadow-md backdrop-blur hover:bg-reader-border"
        style={{
          // safe-area-inset を加味した top/right。 iOS notch / Android nav bar 環境で
          // 自動的に下にずれる。 計算式: 各 inset + 1rem (= 旧 right-4 / top-4 の 4)。
          top: "calc(env(safe-area-inset-top) + 1rem)",
          right: "calc(env(safe-area-inset-right) + 1rem)",
        }}
      >
        ⚙
      </button>
      {open && (
        <SettingsPanel
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
    </>
  );
}
